function updateProductCardVariantImage(productCard, variantId) {
	const hiddenImagesWrapper = productCard.querySelector(`template[data-product-card-variant-images]`);
	if (!hiddenImagesWrapper) return;

	const imageWrapper = productCard.querySelector(`.product-card-nov24__product-image-wrapper`);
    
    let existingVariantImage = imageWrapper?.querySelector(`[data-variant-id="${variantId}"]`);

    if (!existingVariantImage) {
        const variantImage = hiddenImagesWrapper.content.querySelector(`[data-variant-id="${variantId}"]`);
        if (variantImage && imageWrapper) {
            const newImage = variantImage.cloneNode(true);
            imageWrapper.appendChild(newImage);
        }
    }

    const variantImages = imageWrapper?.querySelectorAll(`[data-variant-id`);
    let variantImageFound = false;
    variantImages.forEach((image) => {
        const matchingVariant = image.dataset.variantId === variantId;
        image.classList.toggle('active', matchingVariant);
        if (matchingVariant) variantImageFound = true;
    });


    const productDefaultImage = productCard.querySelector('.product-card-nov24__product-image');
    productDefaultImage?.classList.toggle('active', !variantImageFound);
}

function updateProductPreviewFlavourName(productCard, name) {
    //data-preview-variant-title
    const previewTitle = productCard.querySelector(`[data-preview-flavour-name]`);
    if (!previewTitle) return;
    previewTitle.textContent = name;
}

function initProductCard(productCard) {
    const variantInput = productCard.querySelector('[name="id"]');
    const selectedFlavourName = productCard.querySelector(`[data-selected-flavour-name-block]`);
    const previewFlavourName = productCard.querySelector(`[data-preview-flavour-name-block]`);

    const flavourSwatches = Array.from(productCard.querySelectorAll(".flavour-list__item"));
    flavourSwatches.forEach((flavourSwatch) => {
        flavourSwatch.addEventListener('mouseenter', function() {
            const selectedOption = variantInput.querySelector(`option:checked`);
            const size = selectedOption.dataset.size;
            const flavour = flavourSwatch.dataset.flavour;
            let queryString = `option[data-flavour="${flavour}"]`;
            if (size) queryString += `[data-size="${size}"]`;

            const variantId = variantInput.querySelector(queryString)?.value;
            updateProductCardVariantImage(productCard, variantId);

            // Use flavourSwatch.textContent, instead of dataset.flavour, because dataset.flavour is in handle format
            updateProductPreviewFlavourName(productCard, flavourSwatch.textContent);
            selectedFlavourName?.classList.remove('active');
            previewFlavourName?.classList.add('active');
            
        });
        flavourSwatch.addEventListener('mouseleave', function() {
            selectedFlavourName?.classList.add('active');
            previewFlavourName?.classList.remove('active');

            updateProductCardVariantImage(productCard, variantInput.value);
        });
    })

    updateProductCardVariantImage(productCard, variantInput.value);
}



const productCards = Array.from(document.querySelectorAll('[data-product-card]'));
productCards.forEach((element)=>initProductCard(element));